import {isNumber} from '@/utils/validate';

// 避免浮点数误差导致 toFixed 舍入不准（如 1.005.toFixed(2) === "1.00"）
// Math.round 对负数是向正无穷取整（-1.005 会舍成 -1.00 而非 -1.01），故负数取绝对值舍入后再还原符号
function preciseRound(num, len) {
    if (num < 0) return -preciseRound(-num, len);
    const numStr = num.toString();
    if (numStr.indexOf('e') === -1) {
        return Number(`${Math.round(Number(`${numStr}e${len}`))}e-${len}`);
    }
    const [sig, exp] = numStr.split('e');
    return Number(`${Math.round(Number(`${sig}e${Number(exp) + len}`))}e-${len}`);
}

const filters = {
    reverseBum: function (val, len) {
        if (!val) val = 0;
        let prix = len === undefined ? 3 : len;
        let num = isNumber(val) ? val : Number(val);
        return preciseRound(num, prix).toFixed(prix);
    },
    transNumberToShort: function (value, decimal = 0) {
        if (isNaN(value)) {
            return 0;
        }
        value = Number(value);
        const BASE = 10000;
        const SIZES = ['', '万', '亿', '万亿'];
        let i = undefined;
        let str = '';
        if (value < BASE) {
            str = value.toFixed(decimal);
        } else {
            i = Math.floor(Math.log(value) / Math.log(BASE));
            str = `${(value / Math.pow(BASE, i)).toFixed(decimal)}${SIZES[i]}`;
        }
        return str;
    },
};
export default filters;



// WEBPACK FOOTER //
// ./src/utils/filters.js